module.exports = {"username":"demo.kppbc3","id":"8","group":"beacukai","status":"enabled","detil":{"nama":"Demo Kppbc 3","nip":"321321321312312312","pangkat":"Penata Muda - III/a","kode_eselon2":"160000","eselon2":"Kanwil DJBC Jawa Timur II","kode_eselon3":"070800","eselon3":"KPPBC TMC KEDIRI","kantor":"KPPBC TMC KEDIRI","kantor_id":"070800","kantor_level":"eselon3"},"roleInfo":{"siroleg":[{"role":"siroleg.bc.analis","role_name":"Analis Beacukai","name":"siroleg","domains":"siroleg.beacukai.go.id","description":"Siroleg","icon":null}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_kppbc3.json
// module id = T2Jc
// module chunks = 10